import createIsSubmitting from './selectors/isSubmitting';
import plain from './structure/plain';
export default createIsSubmitting(plain);


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/isSubmitting.js
// module id = 2129
// module chunks = 1